import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BedDouble, ChevronDown, ChevronUp } from "lucide-react";
import { AssignRoomButton } from "@/components/pms/AssignRoomButton";

const fmt = (v) => (v ? new Date(v.slice(0, 10) + "T00:00:00").toLocaleDateString("en-IN", { day: "2-digit", month: "short" }) : "—");

/** ASSIGN-ROOM · bookings in the visible window that have no room yet — sits above the tape chart. */
export function UnassignedTray({ items = [], onAssigned }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  if (!items.length) return null;
  return (
    <div className="border-b border-amber-200 bg-amber-50/70" data-testid="timeline-unassigned-tray">
      <button type="button" onClick={() => setOpen((v) => !v)} className="w-full flex items-center justify-between px-3 py-2 text-left" data-testid="timeline-unassigned-toggle">
        <span className="inline-flex items-center gap-2 text-[12px] font-semibold text-amber-900">
          <BedDouble size={14} strokeWidth={1.5} />{items.length} booking{items.length === 1 ? "" : "s"} without a room in this window
        </span>
        {open ? <ChevronUp size={14} className="text-amber-800" /> : <ChevronDown size={14} className="text-amber-800" />}
      </button>
      {open && (
        <div className="px-3 pb-2 flex gap-2 overflow-x-auto">
          {items.map((u) => (
            <div key={u.reservation_id} className="shrink-0 min-w-[230px] rounded-md border border-amber-200 bg-white px-3 py-2 flex items-center gap-3" data-testid={`unassigned-${u.code}`}>
              <button type="button" onClick={() => navigate(`/pms/reservations/${u.reservation_id}`)} className="text-left min-w-0 flex-1 hover:underline">
                <div className="text-[13px] font-semibold text-[#1A2425] truncate">{u.guest_name || "Guest"}</div>
                <div className="text-[11px] text-[#3F5257] mono truncate">{u.code} · {fmt(u.arrival_date)} → {fmt(u.departure_date)}{u.room_type ? ` · ${u.room_type}` : ""}</div>
              </button>
              {u.is_group ? (
                <button type="button" onClick={() => navigate(`/pms/reservations/${u.reservation_id}?tab=group`)} className="shrink-0 h-8 px-2.5 rounded-md bg-amber-500 hover:bg-amber-400 text-[12px] font-semibold text-[#1A2425]" data-testid={`unassigned-group-${u.code}`}>
                  Assign {u.unassigned_lines} room{u.unassigned_lines === 1 ? "" : "s"}
                </button>
              ) : <AssignRoomButton onAssigned={onAssigned} reservation={{ id: u.reservation_id, code: u.code, guest_name: u.guest_name, status: u.status, hotel_id: u.hotel_id,
                arrival_date: u.arrival_date, departure_date: u.departure_date, requested_room_type_id: u.requested_room_type_id, room_type_name: u.room_type }} />}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
